var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-stepper-header",
    [
      _vm._l(Object.values(_vm.pasos), function(paso) {
        return [
          _c(
            "v-stepper-step",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: paso.visible,
                  expression: "paso.visible"
                }
              ],
              key: "step-" + paso.step,
              attrs: {
                complete: _vm.pasoActivoIndex > paso.step,
                step: paso.step
              }
            },
            [_vm._v(_vm._s(paso.title))]
          ),
          _c("v-divider", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: paso.visible && _vm.contador !== paso.step,
                expression: "paso.visible && contador !== paso.step"
              }
            ],
            key: "divider-" + paso.step
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }